<template>
  <generic-modal
    :title="$t('inventory closing')"
    icon="box alternate"
    image="/images/icons/details.png"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
    ref="modal_element"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="field">
          <label for>{{ $t("closing date") }}</label>
          <div class="ui calendar" ref="calendar">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" name="date" :placeholder="$t('date')" />
            </div>
          </div>
        </div>
        <div class="field">
          <label for>{{ $t("comment") }}</label>
          <textarea name="comment" rows="2" v-model="closure.comment"></textarea>
        </div>
        <div class="ui error message"></div>
      </div>
      <table class="ui celled very compact selectable striped table" ref="table">
        <thead>
          <tr>
            <th>{{ $t("product") }}</th>
            <th>{{ $t("inputs") }}</th>
            <th>{{ $t("outputs") }}</th>
            <th>{{ $t("on hand") }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
  </generic-modal>
</template>

<script>
import { local_api } from "@/utils";
import filters from "@/filters";
import GenericModal from "@/components/GenericModal";
import "datatables.net";
import "datatables.net-se";

export default {
  name: "InventoryOverviewClosureModal",
  filters: filters,
  components: {
    GenericModal
  },
  props: {
    closure_in: Object
  },
  computed: {},
  data() {
    return {
      form: undefined,
      closure: {},
      datatable: undefined
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = vm.form.form("validate form");
        if (!isValid) {
          reject();
        } else {
          local_api(vm, "post", "/inventory_overview/do-update-closure", {
            i: vm.closure.uuid,
            c: vm.closure.comment,
            d: window.jQuery(vm.$refs.calendar).calendar("get date")
          })
            .then(() => {
              vm.$emit("closure_updated");
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    init() {
      let vm = this;
      if (vm.datatable) vm.datatable.destroy();

      let dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/English.json";
      if (vm.$i18n.locale == "es")
        dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/Spanish.json";
      else if (vm.$i18n.locale == "fr")
        dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/French.json";

      if (vm.closure) {
        // setTimeout(() => {
        vm.datatable = window.jQuery(vm.$refs.table).DataTable({
          data: vm.closure.inv_closing_products,
          language: {
            url: dict
          },
          columns: [
            {
              data: function(row) {
                return row.prd_product.name;
              }
            },
            {
              data: function(row) {
                return row.input_sum;
              }
            },
            {
              data: function(row) {
                return row.output_sum;
              }
            },
            {
              data: function(row) {
                return row.input_sum - row.output_sum;
              }
            }
          ],
          createdRow: function(row, data) {
            window.jQuery(row).click(function() {
              console.log(data);
            });
          }
        });
        // }, 400);
      }
    }
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.calendar).calendar({
      type: "date",
      today: true,
      onChange(date) {
        vm.closing_date = date;
      }
    });

    vm.$refs.modal_element.set_loading(true);

    vm.form = window.jQuery(vm.$refs.form).form({
      fields: {
        date: ["empty"]
      }
    });
  },
  created() {
    let vm = this;
    if (vm.closure_in) {
      local_api(vm, "post", "/inventory_overview/do-get-closure", {
        i: vm.closure_in.uuid
      })
        .then(c => {
          vm.closure = c;
          vm.init();
          vm.$refs.modal_element.set_loading(false);
          if (c) {
            window
              .jQuery(vm.$refs.calendar)
              .calendar("set date", c.closing_date);
          }
        })
        .catch(err => {
          console.error(err);
          vm.$alertify.error(JSON.stringify(err));
        });
    }
  },
  watch: {},
  updated: function() {}
};
</script>
